import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ItemCard from '../../../components/common/ItemCard';
import Slider from 'react-slick';
import { alertWrapper } from '../../../utils/alertWrapper';
import { jacketVariants } from '../../../utils/staticData';

const settings = {
  dots: false,
  className: 'center',
  centerMode: true,
  infinite: true,
  centerPadding: '100px',
  slidesToShow: 1,
  speed: 500,
  prevArrow: <div className="slick-prev">Previous</div>,
  nextArrow: <div className="slick-next">Next</div>,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        centerMode: false
      }
    }
  ]
};

const ItemsCarousel = ({
  selectedCategory,
  setSelectedCategory,
  variantData,
  isDataReady,
  setIsDataReady,
  setIsLoading,
  selectedVariant,
  openAlertDialog,
  isConfigSaved,
  setCurrentActiveParent,
  getAccessoryVariantData
}) => {
  const [shouldOpen, setShouldOpen] = useState(true);
  const [activeJacketType, setActiveJacketType] = useState(-1);
  const [isAlertConfirmed, setIsAlertConfirmed] = useState(true);

  const variantInfo = variantData.map((data, index) => {
    return {
      ...jacketVariants[index],
      ...data
    };
  });

  const onVariantChange = (i, option) => {
    setIsLoading(true);
    setActiveJacketType(i);
    setCurrentActiveParent(null);
    getAccessoryVariantData(option.variantId);
    setTimeout(() => {
      setShouldOpen(false);
      setSelectedCategory('jacketColour');
    }, 400);
  };

  const onVariantChangeCancel = () => {
    setIsLoading(true);
    setShouldOpen(false);
    setSelectedCategory('jacketColour');
    if (!isDataReady) {
      setTimeout(() => {
        setIsDataReady(true);
      }, 10);
    }
  };

  useEffect(() => {
    if (selectedCategory === 'chooseJacketShell') {
      setShouldOpen(true);
      setIsDataReady(false);
    } else if (isDataReady) {
      // setShouldOpen(false);
    }
  }, [selectedCategory]);

  useEffect(() => {
    // if (selectedVariant) setShouldOpen(false);
  }, [selectedVariant]);

  const isValidData = variantData.every(value =>
    value.accessoryCategory.includes('jacket')
  );

  return (
    isValidData && (
      <div
        className={`item-carousel ${shouldOpen ? 'item-carousel--opened' : ''}`}
      >
        <div className="item-carousel_container">
          <h1 className="item-carousel_title">SELECT TYPE OF SHELL</h1>
          <Slider {...settings}>
            {variantInfo.map((option, i) => (
              <ItemCard
                title={option.name}
                imageUrl={option.thumbnail}
                features={option.features}
                onSelect={() => {
                  alertWrapper(
                    {
                      isOpen:
                        selectedVariant !== '' &&
                        !isConfigSaved &&
                        !isAlertConfirmed,
                      title: 'Customization Not Saved',
                      message:
                        'Changing Variant without saving will result in lose of customization. Click on Save on Topbar or continue anyway without saving',
                      agreeButtonText: 'Continue Anyway',
                      disagreeButtonText: 'Cancel',
                      onAgree: () => {
                        onVariantChange(i, option);
                        setIsAlertConfirmed(false);
                      },
                      onDisagree: onVariantChangeCancel
                    },
                    openAlertDialog,
                    selectedVariant !== '' && !isConfigSaved
                  );
                  if (isAlertConfirmed) {
                    onVariantChange(i, option);
                    setIsAlertConfirmed(false);
                  }
                }}
              />
            ))}
          </Slider>
        </div>
      </div>
    )
  );
};

ItemsCarousel.propTypes = {
  title: PropTypes.string,
  options: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    imageUrl: PropTypes.string
  }),
  onSelect: PropTypes.func
};

export default ItemsCarousel;
